/**
 * 生产计划管理
 */
 import axios from '../request';
 export default{
    /**
     * 管片原料理论放量
     */
    // 查询管片原料理论放量信息
    searchDuctRaw: params =>
        axios({
            method: 'post',
            url: '/materials/rsbMaterialPlan/findList',
            headers: {
              pageNum: params.pageNum,
              pageSize: params.pageSize
            },
            data:params
          }),
    // 添加管片原料理论放量信息
    insertDuctRaw: params =>
        axios.post('/materials/rsbMaterialPlan/addRsbMaterialPlan', params),
    // 修改管片原料理论放量信息
    updateDuctRaw: params =>
        axios.post('/materials/rsbMaterialPlan/addRsbMaterialPlan', params),
    // 删除管片原料理论放量信息
    deleteDuctRaw: params =>
        axios.post('/materials/rsbMaterialPlan/delete', params),
    //获取计划原料列表
    getPlanList: params =>
        axios.post('/materials/rsbMaterialPlan/info', params),
    //导出按钮
    // exportBtns: params =>
    //     axios.post('/usercore/sysUser/getAuthCode', params),
    exportBtns: params =>
        // axios.post('/materials/mixingstationstorage/statExport', params),
        axios({
        method: 'post',
        url: '/materials/mixingstationstorage/statExport',
        responseType: 'blob',
        data: params
    }),

    /**
     * 管片生产计划
     */
    // 查询管片生产计划信息
    searchDuctPlan: params =>
        axios.post('/materials/pipePlan/findList', params),
    // 添加管片生产计划信息
    insertDuctPlan: params =>
        axios.post('/materials/pipePlan/addPipePlan', params),
    // 修改管片生产计划信息
    updateDuctPlan: params =>
        axios.post('/materials/pipePlan/addPipePlan', params),
    // 删除管片生产计划信息
    deleteDuctPlan: params =>
        axios.post('/materials/pipePlan/delete', params),
    //获取月份列表
    getMonthsList: params =>
    axios.post('/materials/pipePlan/monthList', params),

    /**
     * 原料实际放量
     */
    practicalRaw: {
        getLists: params =>
            axios.post('/materials/materialRelease/materialReleaseList', params),
        insert: params =>
            axios.post('/materials/materialRelease/materialReleaseInsert', params),
        update: params =>
            axios.post('/materials/materialRelease/materialReleaseUpdate', params),
        delete: params =>
            axios.get('/materials/materialRelease/materialReleaseDel', { params }),
        getMaterialNames: params =>
            axios.get('/materials/materialRelease/dictList', { params }),
        exportXls: params =>
            axios({
                method: 'post',
                url: '/materials/materialRelease/materialReleaseExcel',
                responseType: 'blob',
                data: params
            }),
    }
 }